import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Filter, Sliders } from 'feather-icons-react/build/IconComponents';
import { ImageWithBasePath } from 'Core/components';
import Select from 'react-select';
import { actions as receivingActions, fetchReceivingShipmentsWithFilters } from './store/slice';
import { selectReceivingFilterVisible, selectReceivingShipmentFilters } from './store/selectors';

const { setFilterVisible, setPageSearchText, setSupplier, setStatus, setShipmentDate } =
  receivingActions;

const MappingsSearch = () => {
  const dispatch = useDispatch();
  const filterVisible = useSelector(selectReceivingFilterVisible);
  const { pageSearchText } = useSelector(selectReceivingShipmentFilters);
  const searchTimerRef = useRef(null);

  useEffect(() => {
    return () => {
      if (searchTimerRef.current) {
        clearTimeout(searchTimerRef.current);
      }
    };
  }, []);

  const handleSearch = e => {
    const value = e.target.value;
    dispatch(setPageSearchText(value));
    if (searchTimerRef.current) {
      clearTimeout(searchTimerRef.current);
    }
    searchTimerRef.current = setTimeout(() => {
      dispatch(fetchReceivingShipmentsWithFilters());
    }, 400);
  };

  const toggleFilterVisibility = e => {
    e.preventDefault();
    e.stopPropagation();
    const opening = !filterVisible;
    dispatch(setFilterVisible(opening));

    if (!opening) {
      dispatch(setSupplier(null));
      dispatch(setStatus(null));
      dispatch(setShipmentDate(null));
      dispatch(setPageSearchText(''));
      dispatch(
        fetchReceivingShipmentsWithFilters({
          supplier: null,
          status: null,
          shipmentDate: null,
          pageSearchText: '',
        }),
      );
    }
  };

  const oldandlatestvalue = [
    { value: 'date', label: 'Sort by Date' },
    { value: 'newest', label: 'Newest' },
    { value: 'oldest', label: 'Oldest' },
  ];

  return (
    <>
      <div className="search-set">
        <div className="search-input">
          <button type="button" className="btn btn-searchset">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-search"
            >
              <circle cx={11} cy={11} r={8} />
              <line x1={21} y1={21} x2="16.65" y2="16.65" />
            </svg>
          </button>
          <div id="DataTables_Table_0_filter" className="dataTables_filter">
            <label>
              {' '}
              <input
                type="search"
                className="form-control form-control-sm"
                placeholder="Search by supplier, shipment number..."
                aria-controls="DataTables_Table_0"
                value={pageSearchText || ''}
                onChange={handleSearch}
              />
            </label>
          </div>
        </div>
      </div>
      <div className="search-path">
        <button
          type="button"
          className={`btn btn-filter ${filterVisible ? 'setclose' : ''}`}
          id="receiving_filter_search"
          onClick={toggleFilterVisibility}
          aria-label={filterVisible ? 'Close filters' : 'Open filters'}
        >
          <Filter className="filter-icon" />
          <span>
            <ImageWithBasePath src="assets/img/icons/closes.svg" alt="img" />
          </span>
        </button>
      </div>
      <div className="form-sort" style={{ display: 'none' }}>
        <Sliders className="info-img" />
        <Select
          className="img-select"
          classNamePrefix="react-select"
          options={oldandlatestvalue}
          placeholder="Newest"
        />
      </div>
    </>
  );
};

export default MappingsSearch;
